import { Button, Center, Container, Heading, HStack, Input, Stack } from '@chakra-ui/react'
import { RecaptchaVerifier } from 'firebase/auth';
import React from 'react'
import AppHeader from '../../Components/AppHeader'
import { auth } from '../../Config/firebase';

function SignUpPage() {
	// window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {}, auth);

	
  return (
	<>

	<Center height='90vh' >
		<Stack>
		<Heading>Sign Up</Heading>
		<Input type='text' maxW='2xs' placeholder='No Handphne'/>
		<Input type='text' maxW='2xs' placeholder='Nama'/>
		<Input type='text' maxW='2xs' placeholder='Email (optional)'/>
		{/* <Input type='password' maxW='2xs' placeholder='Password'/> */}
		{/* <Input type='password' maxW='2xs' placeholder='Konfirmasi password'/> */}
		<Button colorScheme='green'>Daftar</Button>
		<HStack>
		</HStack>

		</Stack>
	</Center>
	</>
  )
}

export default SignUpPage